'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("ticketEditionClientPopinController", function ($scope, $http, $session, $dialogBox, $translate, UUID, documentDrop, documentPreview) {
  var isEdit = $scope.edit;
  var originalTicket = isEdit ? $scope.ticket : {
    documentsIn: [],
    watcherIds: [],
    demandeurUtilisateurId: $session.getUser().id
  };
  $scope.compteVisualiseId = $session.getCompte().id;
  $scope.showDemandeFileDropOverlay = function () {
    return documentDrop.isActive();
  };
  $scope.params = {
    newWatcherId: null
  };
  var ticket = $scope.ticket = angular.copy(originalTicket);
  $http.get('/rest/echange/assignableUsers').then(function (response) {
    $scope.users = _.map(response.data, function (user) {
      return {
        id: user.id,
        label: user.prenom + " " + user.nom
      };
    });
  });
  $http.get('/rest/echange/demandeurs', {
    params: {
      compteId: ticket.compteId
    }
  }).then(function (response) {
    $scope.demandeurs = _.map(response.data, function (user) {
      return {
        id: user.id,
        label: (user.prenom != null ? user.prenom + " " : "") + user.nom,
        actif: user.actif
      };
    });
  });
  $scope.watcherList = function () {
    return _.filter($scope.demandeurs, function (d) {
      return d.actif && d.id !== $scope.ticket.demandeurUtilisateurId && _.indexOf($scope.ticket.watcherIds, d.id) === -1;
    });
  };
  $scope.removeWatcher = function (id) {
    var index = _.indexOf($scope.ticket.watcherIds, id);
    $scope.ticket.watcherIds.splice(index, 1);
  };
  $scope.addWatcher = function () {
    var watcherId = $scope.params.newWatcherId;

    // si non deja présent dans la liste on l'ajoute
    if (watcherId != null && watcherId !== $scope.ticket.demandeurUtilisateurId && _.indexOf($scope.ticket.watchersId, watcherId) === -1) {
      if ($scope.ticket.watcherIds == null) {
        $scope.ticket.watcherIds = [];
      }
      $scope.ticket.watcherIds.push(watcherId);
    }
    $scope.params.newWatcherId = null;
  };
  $scope.renderUser = function (userId) {
    if ($scope.demandeurs) {
      var ts = _.find($scope.demandeurs, {
        id: userId
      });
      if (ts) {
        var label = ts.label;
        if (!ts.actif) {
          label += " (désactivé)";
        }
        return label;
      }
      return "[" + userId + "]";
    }
  };
  $scope.ticketFormConfig = {
    url: function url() {
      return '/rest/echange/ticket-client/' + (isEdit && ticket.id || "");
    },
    data: function data() {
      return ticket;
    },
    fieldPrefix: "ticket.",
    fields: {
      // non implementé par tlValdatedField... on fait en back pour le moment
      demande: {
        mandatory: true
      }
    },
    onSuccess: function onSuccess(savedTicket) {
      _.extend(ticket, savedTicket);
      $scope.$close(ticket);
    },
    onError: function onError(errors) {}
  };
  var refreshDocumentsTable = function refreshDocumentsTable() {
    $scope.documentsTableConfig = {
      source: "ticket.documentsIn",
      id: "ticketDocumentsTable",
      height: 600,
      columns: [{
        attribute: "name",
        title: 'Nom'
      }, {
        attribute: 'name',
        title: "Actions",
        cellClass: "align-c",
        template: '' + '<div>' + '   <tl-icon-button ng-if="canPreviewDoc(model)" icon="fa-eye" title="Visualiser" ng-click="previewDocument(model)"></tl-icon-button>' + '   <tl-icon-button icon="delete" tl-tooltip="Supprimer" ng-click="removeDocument(model)"></tl-icon-button>' + '</div>'
      }]
    };
  };
  refreshDocumentsTable();
  $scope.uploadDocumentOptions = {
    url: '/rest/echange/ticket-client/upload-temp-document',
    dropZone: '.documents-drop-zone'
  };
  $scope.onDocumentUpload = function (result) {
    var document = {
      id: UUID(),
      fileId: result.fileId,
      name: result.fileName,
      type: 'TICKET_IN',
      size: result.fileSize,
      creationDate: new Date(),
      creationUserId: $session.getUser().id
    };
    $scope.ticket.documentsIn.push(document);
    refreshDocumentsTable();
  };
  $scope.canPreviewDoc = function (document) {
    return documentPreview.canPreview(document);
  };
  $scope.previewDocument = function (document) {
    documentPreview.openPopin(document, '/rest/echange/ticket-client/preview-temp-document/' + document.fileId);
  };
  $scope.removeDocument = function (document) {
    $dialogBox.confirm({
      title: $translate("common.confirm_delete"),
      text: $translate("saisie.documents.popins.delete.text", {
        filename: document.name
      })
    }).then(function () {
      $scope.ticket.documentsIn = _.filter($scope.ticket.documentsIn, function (d) {
        return d.id !== document.id;
      });
      refreshDocumentsTable();
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ticket/editionClient/ticketEditionClientPopinController.js
// module id = 2890
// module chunks = 13